export enum CompanyTypes {
	PUBLIC_COMPANY = 'Public Company',
	PRIVATE_HELD = 'Private Held',
	RECRUITMENT_AGENCY = 'Recruitment Agency',
	EDUCATIONAL_INSTITUTION = 'Educational Inistitution',
	GOVERNMENT_AGENCY = 'Government Agency',
	NON_PROFIT = 'Non-Profit'
}
